const defaultAppComponentsData = require("../../tusk/modules/appComponents");

const betsurAppComponents = {
    LanguageSwitcher: () => import('./components/layout/LanguageSwitcher.vue'),
    TheFooter: () => import('./components/layout/TheFooter.vue'),
    Register: () => import('./components/signIn/Register.vue'),
    QuickRegister: () => import('./components/signIn/QuickRegister.vue'),
    SignIn: () => import('./components/signIn/SignIn.vue'),
    RegistrationForm: () => import('./components/signIn/RegistrationForm.vue'),
    LoginForm: () => import('./components/signIn/LoginForm.vue'),
    ForgotPassword: () => import('./components/signIn/ForgotPassword.vue'),
    TheAccount: () => import('./components/account/TheAccount.vue'),
    PromotionSlider: () => import('./components/pages/parts/itemSets/PromotionSlider.vue'),

    /* SPORTBOOK */
    Sportsbook: () => import('./components/pages/parts/target/AltenarSportsbook.vue'),
};

const betsurEntryPointComponents = {

};

let appComponents = Object.assign(defaultAppComponentsData.appComponents, betsurAppComponents);

let entryPointComponents = Object.assign(defaultAppComponentsData.entryPointComponents, betsurEntryPointComponents);

module.exports = {
    appComponents,
    entryPointComponents,
};
